import * as React from 'react';
import {
    AssemblyCountryInfoModalDispatchProps,
    EmailChangedModalDispatchProps,
    MediciValidationsModalDispatchProps
} from '../../types/containers';

class AssemblyCountryInfoModalView
    extends React.Component<AssemblyCountryInfoModalDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                El país de fabricación o ensamblaje se determina por el primer carácter del VIN(Número de Identificación Vehicular).
                Ejemplos: "3” = México, "1,4,5” = EE.UU., "J” = Japón, "2" = Canadá, "K" = Corea, "W" = Alemania, "Z” = Italia.
                Si no puedes revisar el VIN, puedes consultar la factura emitida.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressClose) {
        return <React.Fragment>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressClose}>Entendido</a></React.Fragment>;
    }

    render() {
        const {onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressClose)}
                </div>
            </div>
        );
    }
}

export default AssemblyCountryInfoModalView;
